import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/app/(public)/[sport]/teams/[team]/[year]/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/game/odds/table.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/primitives/icon.tsx");
